import * as React from 'react';

function EmptyValuationsFree() {
  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
       <p><strong>Preset Valuations</strong></p>
        <div>
          Upgrade to premium to save valuations.
        </div>
      </p>
    </div>
  );
}

export default EmptyValuationsFree;
